<!--<kinetix-grid [items]="items" [options]="gridOptions"></kinetix-grid>-->
<data-mapping-grid
  [readonly]="true"
  [dataMapping]="mapping">
</data-mapping-grid>